import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import readXlsxFile from 'read-excel-file'; //lee data importada

import Button from 'components/CustomButtons/Button.js';
import { CloudDownload, Backup, Close } from '@material-ui/icons';

import { makeStyles } from '@material-ui/core/styles';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  IconButton,
  Tooltip
} from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Toasty, useToasty } from 'hooks/Toasty';

import ReactExport from 'react-data-export';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  input: {
    display: 'none'
  }
}));

const styleExcel = {
  fill: { patternType: 'solid', fgColor: { rgb: '4bdd90' } },
  border: {
    top: { style: 'thin' },
    bottom: { style: 'thin' },
    left: { style: 'thin' },
    right: { style: 'thin' }
  }
};

/**
 * read-excel-file devuelve la celda con formato de fecha como objeto Date, que
 * React no sabe pintar y que cada pantalla tendría que resolver por su cuenta.
 *
 * Se pasa a dd/mm/aaaa, que es como llega cuando la celda es texto: así el
 * consumidor recibe siempre lo mismo, venga formateada como fecha o escrita a
 * mano. Es lo que ya asumía StatementBank con su moment(item.Fecha,'DD/MM/YYYY').
 */
function celdaExcel(valor) {
  if (!(valor instanceof Date)) return valor;

  const dia = String(valor.getDate()).padStart(2, '0');
  const mes = String(valor.getMonth() + 1).padStart(2, '0');
  return `${dia}/${mes}/${valor.getFullYear()}`;
}

function ImportExcel({
  fileInputId = 'file-excel',
  setDataImport,
  btnColor,
  btnLabel,
  validDuplicate,
  sortDuplicate = undefined,
  downTemplate = undefined,
  inputRef = undefined,
  onChange = undefined,
}) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const [columnsExport, setColumnsExport] = useState({ headers: [], values: [] });

  /* const  = props; */
  //#region  import
  const [initEvent, setInitEvent] = useState(false);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [datafile, setDataFile] = useState({});

  /**
   * Retorna la key del objeto para verificar duplicados
   * Si validDuplicate es string, el valor del campo,
   * Si validDuplicate es array, el valor de los campos especificados con un join(',')
   */
  function getObjectKey(obj){
    if(typeof validDuplicate === 'string'){
      return obj[validDuplicate];
    }

    let data = [];
    for(let key of validDuplicate){
      data.push(obj[key]);
    }
    return data.join(',');
  }

  const convert = (selectFile) => {
    if (selectFile?.name?.includes('~$')) {
      showNotify('Archivo no disponible: ciérrelo en caso de tenerlo abierto', 'error');
      return;
    }
    if (!selectFile) {
      showNotify('Ocurrió un error', 'error');
      return;
    }
    setInitEvent(true);
    readXlsxFile(selectFile).then((rows) => {
      const header = rows[0];
      setColumns(header);
      rows.shift();

      let newData = [];
      for (let item of rows) {
        let data = {};
        for (let i = 0; i < item.length; i++) {
          data[header[i]] = celdaExcel(item[i]);
        }
        newData.push(data);
      }

      const searchDuplicates = newData.reduce((acc, obj) => {
        let key = getObjectKey(obj);
        acc[key] = ++acc[key] || 0;
        return acc;
      }, {});

      const arrDuplicates = newData.filter((obj) => {
        let key = getObjectKey(obj);
        return searchDuplicates[key]; 
      });

      const keys = newData.map(item => {
        let key = getObjectKey(item);
        return key
      });
      const dataNoDuplicate = newData.filter(
        (item, i) => {
          return !keys.includes(getObjectKey(item), i + 1);
        }
      );
      setData(dataNoDuplicate);

      let duplicates;
      if(sortDuplicate === undefined){
        duplicates = arrDuplicates;
      }else{
        duplicates = arrDuplicates?.sort((a, b) => {
          const valueA = a[sortDuplicate]?.toString();
          const valueB = b[sortDuplicate]?.toString();
          return valueA?.localeCompare(valueB);
        });
      }

      setDataFile({
        nameExcel: selectFile.name,
        totalRows: dataNoDuplicate?.length,
        duplicates,
      });
    });
  };
  // #endregion

  const reset = () => {
    setInitEvent(false);
    setColumns([]);
    setData([]);
    setDataFile({});
  };

  const onResultAction = (res = false) => {
    if (res) {
      setDataImport({ success: true, nameFile: datafile.nameExcel, data: data });
      reset();
    } else {
      setDataImport({ success: false, nameFile: '', data: [] });
      reset();
    }
  };

  const generateColumnsExcel = () => {
    const columns = downTemplate.fields?.map((item) => {
      return { title: item, style: { ...styleExcel } };
    });
    let values = [];
    if(downTemplate.data === undefined){
      for (let obj of downTemplate.fields) {
        values.push({ value: '' });
      }
      values = [values];
      setColumnsExport({ headers: columns, values });
      return;
    }

    if(typeof downTemplate.data === 'function'){
      setColumnsExport({ headers: columns, values: downTemplate.data() });
    }else{
      for (let obj of downTemplate.data) {
        let data = [];
        for(let key of downTemplate.fields){
          data.push({value: 'hola'});
        }
        values.push(data);
      }
      setColumnsExport({ headers: columns, values });
    }

    
  };

  useEffect(() => {
    if (downTemplate) {
      generateColumnsExcel(downTemplate.fields);
    }
  }, [downTemplate]);

  return (
    <>
      <Toasty action={notify} />
      <input
        key={initEvent}
        className={classes.input}
        id={fileInputId}
        type="file"
        ref={inputRef}
        accept=".xls,.xlsx"
        onChange={(e) => {
          if (onChange !== undefined) onChange(e);
          else convert(e.target.files[0]);
        }}
      />
      <label htmlFor={fileInputId}>
        <Tooltip title="Importar excel">
          <Button
            justIcon={btnLabel ? false : true}
            size="sm"
            color={btnColor ? btnColor : 'primary'}
            style={{ marginLeft: '15px' }}
            component="span"
          >
            <Backup /> {btnLabel ? btnLabel : ''}
          </Button>
        </Tooltip>
      </label>
      {downTemplate ? (
        <ExcelFile
          element={
            <Tooltip title="Descargar plantilla">
              <Button color="info" size="sm" justIcon style={{ marginLeft: '7px' }}>
                <CloudDownload />
              </Button>
            </Tooltip>
          }
          filename={downTemplate.fileNameDown}
        >
          <ExcelSheet
            dataSet={[
              {
                columns: columnsExport.headers,
                data: columnsExport.values,
              },
            ]}
            name="Plantilla"
          />
        </ExcelFile>
      ) : undefined}
      {initEvent ? (
        <ShowDataImport
          columns={columns}
          data={data}
          datafile={datafile}
          response={onResultAction}
        />
      ) : undefined}
    </>
  );
}

function ShowDataImport({ columns, data, datafile, response }) {
  const classes = useStyles();

  const [open, setOpen] = useState(true);
  const eventClose = (state) => {
    setOpen(false);
    response(state === true ? true : false);
  };

  const [showDuplicates, setShowDuplicates] = useState(false);

  return (
    <Dialog onClose={eventClose} open={open} maxWidth="lg">
      <DialogTitle onClose={() => eventClose(false)}>
        <b>{datafile.nameExcel}</b>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => eventClose(false)}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {datafile.duplicates?.length > 0 ? (
          <div
            style={{
              backgroundColor: '#fff2ea',
              borderRadius: '7px',
              padding: '10px 10px 1px 10px',
              marginBottom: '10px'
            }}
          >
            <Button
              autoFocus
              onClick={() => setShowDuplicates(!showDuplicates)}
              color="danger"
              size="sm"
              style={{ marginBottom: '15px' }}
            >
              Ver ( {datafile.duplicates?.length} ) Duplicados
            </Button>
            {showDuplicates ? (
              <TableData columns={columns} data={datafile.duplicates} />
            ) : undefined}
            <p style={{ color: 'red', fontWeight: 500 }}>
              Se eliminaron los registros duplicados (Se ha considerado solo 1 válido por registro
              duplicado)
            </p>
          </div>
        ) : undefined}

        <TableData columns={columns} data={data} />
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between', padding: '10px 17px 10px 23px' }}>
        <b>Total {datafile.totalRows} registros válidos</b>
        <div>
          <Button autoFocus onClick={() => eventClose(true)} color="success" size="sm">
            Aceptar
          </Button>
          <Button autoFocus onClick={() => eventClose(false)} color="danger" size="sm">
            Cerrar
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

function TableData({ columns, data }) {
  return (
    <TableContainer component={Paper}>
      <Table style={{ minWidth: 650 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            {columns.map((item, i) => {
              return <TableCell key={i}>{item}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, i) => {
            return (
              <TableRow key={i}>
                <TableCell>{i + 1}</TableCell>
                {columns.map((col, i) => {
                  return <TableCell key={i}>{item[col]}</TableCell>;
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ImportExcel.propTypes = {
  fileInputId: PropTypes.string,
  setDataImport: PropTypes.func,
  btnColor: PropTypes.string,
  btnLabel: PropTypes.string,
  validDuplicate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  sortDuplicate: PropTypes.string
};

export { ImportExcel };
